import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { compose } from "redux";

import * as homeReducer from "containers/Home/reducer";
import * as nextReducer from "containers/Next/NextReducer";

import ComparisonChart from "components/Next/Charts/ComparisonChart";

const getId = (props) =>
  props && props.id
    ? props.id
    : props.datasetId
      ? props.datasetId
      : props && props.match && props.match.params && props.match.params.datasetId
        ? props.match.params.datasetId
        : "new";

class ComparisonChartContainer extends React.Component {
  constructor(props) {
    super(props);
  }

  shouldComponentUpdate(nextProps) {
    const { node, isReport, hoverGroup } = this.props;

    return node !== undefined && node?.chart?.narrative?.title !== nextProps?.node?.chart?.narrative?.title
      ? true
      : node !== undefined
        ? false
        : true;
  }

  render() {
    return <ComparisonChart {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => {
  const id = getId(ownProps);

  return {
    handleMuscleClick: (field) => dispatch(nextReducer.handleMuscleClick(id, field))
  };
};
const mapStateToProps = (state, ownProps) => {
  const id = getId(ownProps);
  const datasetId = ownProps?.datasetId || nextReducer.getDatasetId(state, id);
  const isReport = ownProps.isReport;
  const isExploreTask = ownProps.isExploreTask;

  return ownProps?.node || isReport || isExploreTask
    ? {
        id: id,
        dataset: homeReducer.getDataset(state, datasetId),
        rankedFields: homeReducer.getRankedFields(state, datasetId),

        insights: nextReducer.getTreemapData(state, id),
        comparisonOptions: nextReducer.getComparisonOptions(state, id),

        outcome: homeReducer.getDataset(state, datasetId)?.outcome,
        datasetSuccess: nextReducer.getDatasetSuccess(state, id),

        gridType: nextReducer.getGridType(state, id),

        ...nextReducer.getHoverFromNode(
          state,
          ownProps?.node ? ownProps.node : isExploreTask ? ownProps?.node : ownProps?.node?.chart
        )
      }
    : {
        id: id,
        dataset: homeReducer.getDataset(state, datasetId),
        rankedFields: homeReducer.getRankedFields(state, datasetId),

        insights: nextReducer.getTreemapData(state, id),
        comparisonOptions: nextReducer.getComparisonOptions(state, id),

        hoverGroup: nextReducer.getHoverGroup(state, id),
        hoverRibbon: nextReducer.getHoverRibbon(state, id),
        hoverNode: ownProps.hoverNode !== undefined ? ownProps?.hoverNode : nextReducer.getHoverNode(state, id),

        gridType: nextReducer.getGridType(state, id),
        searchOptions: nextReducer.getSearchOptions(state, id),

        isHideSearch: nextReducer.getIsHideSearch(state, id),

        outcome: homeReducer.getDataset(state, datasetId)?.outcome,
        datasetSuccess: nextReducer.getDatasetSuccess(state, id)
      };
};

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect, withRouter)(ComparisonChartContainer);
